import React, { useState, useEffect, useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";
import CustomGoogleAutoComplete from "../google-input/CustomGoogleAutoComplete";
import { useTranslation } from "react-i18next";
import { generateRandom } from "../../../utils/Calculator";
import { cn } from "../../../utils/classnames";
import { LocationPinIcon } from "../../icons";
import { DURATION, EASE_OUT } from "../../motion";

const MultipleDropOff = ({
  setDestinations,
  dropofflocations,
  isNotValidFirstLocation,
  changeValidation,
  isUseAddDestination,
}) => {
  const { t } = useTranslation();
  const [inputFields, setInputFields] = useState([{}]);
  const shouldReduceMotion = useReducedMotion();
  // Index of the drop-off row the customer just added, so only that row eases
  // open. A ref, not state: clearing it must not re-render (and so remount)
  // the rows while the customer may already be typing in the new one.
  const justAddedRowIndexRef = useRef(null);

  useEffect(() => {
    setInputFields(dropofflocations);
  }, [dropofflocations]);

  const addInputField = () => {
    const hasData = inputFields[inputFields.length - 1]?.label;
    if (inputFields.length === 0) {
      justAddedRowIndexRef.current = inputFields.length;
      setInputFields([...inputFields, {}]);
      changeValidation(true);
    } else if (hasData !== undefined) {
      justAddedRowIndexRef.current = inputFields.length;
      setInputFields([...inputFields, {}]);
      changeValidation(true);
    } else {
      changeValidation(false);
    }
  };

  const removeInputFields = (index, value) => {
    const newValues = inputFields.filter((i) => i.value !== value);
    setInputFields(newValues);
    setDestinations(newValues);
  };
  const locationSelected = (index, place) => {
    if (place === undefined) return;
    var newPLace = { ...place };
    // const city = place.address_components.find((c) =>
    //   c.types[0].includes("administrative_area_level_1")
    // ).long_name;
    const level1 = place.address_components.find(c => c.types.includes("administrative_area_level_1"));

    const city = level1?.long_name || null;
    newPLace.lat = place.geometry.location.lat;
    newPLace.lon = place.geometry.location.lng;
    newPLace.label = place.formatted_address;
    newPLace.formatted_address = place.formatted_address;
    newPLace.value = generateRandom(1000, 200000);
    newPLace.city = city;
    newPLace.place_id = place.place_id;
    newPLace.types = place.types;
    newPLace.prefecture = city;

    let list = inputFields.slice();

    list.splice(index, 1, newPLace);

    setInputFields(list);
    setDestinations(list);

    changeValidation(true);
  };

  return (
    <div>
      {inputFields.map((location, index) => {
        const isJustAddedRow = index === justAddedRowIndexRef.current && !shouldReduceMotion;
        return (
          <motion.div
            className="tw:grid tw:grid-cols-5 tw:gap-3"
            key={"loc" + (Math.random() + 1).toString(36).substring(7)}
            // Only a newly added row animates: it grows open and fades in.
            // Overflow goes back to visible afterwards so the suggestion list
            // can drop out below it.
            initial={isJustAddedRow ? { height: 0, opacity: 0, overflow: "hidden" } : false}
            animate={{ height: "auto", opacity: 1, transitionEnd: { overflow: "visible" } }}
            transition={{ duration: DURATION.fast, ease: EASE_OUT }}
            onAnimationComplete={() => {
              if (isJustAddedRow) justAddedRowIndexRef.current = null;
            }}
          >
            <div className={cn("tw:col-span-5 input-box", inputFields.length > 1 && (inputFields.length - 1) !== index ? 'tw:lg:col-span-5' : 'tw:lg:col-span-3')}>
              <div
                className={`form-floating position-relative ${inputFields.length !== 1 && index !== 0 ? `tw:mt-3` : ``}`}
              >
                <CustomGoogleAutoComplete
                  resetButton={index > 0 ? false : true}
                  id={
                    "multi goog" + (Math.random() + 1).toString(36).substring(7)
                  }
                  placeholder="Drop-off address"
                  onPlaceSelected={(location) => {
                    locationSelected(index, location);
                  }}
                  defaultValue={
                    location?.label === undefined ? null : location?.label
                  }
                  invalidText={
                    "SpecifiedDestination.Pickup.Specific.Validation"
                  }
                />
                {inputFields.length !== 1 ? (
                  <i
                    className="fa fa-close icon tw:absolute tw:top-1/2 tw:-translate-y-1/2 tw:cursor-pointer"
                    onClick={() => removeInputFields(index, location.value)}
                  ></i>
                ) : (
                  ``
                )}

                <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                  <div className="d-flex justify-content-center">
                    <LocationPinIcon />
                  </div>
                </span>
                <label htmlFor="dropOffAddress" className="label-icon">
                  {t("Drop.Off.Address")}
                </label>
              </div>
            </div>
            {index === inputFields.length - 1 && (
              <div className={`tw:col-span-5 tw:lg:col-span-2 d-grid d-md-block ps-md-0 ${inputFields.length !== 1 ? `tw:md:!mt-3` : `tw:md:!mt-0`}`}>
                <button
                  disabled={!isUseAddDestination}
                  type="button"
                  className="btn btn-add-destination btn-lg rounded-3 d-flex justify-content-center w-full px-3 py-3 tw:h-[50px] tw:w-full"
                  onClick={addInputField}
                >
                  <div className="d-flex align-items-center px-2 d-inline">
                    <div className="pe-2 d-inline">
                      <i className="bi bi-plus d-flex align-items-center justify-content-center"></i>
                    </div>
                    {t("Add.Destination")}
                  </div>
                </button>
              </div>
            )}
          </motion.div>
        );
      })}
    </div>
  );
};

export default MultipleDropOff;
